import React, { useState } from 'react';

import ReactDOM from 'react-dom';
import { useForm } from "react-hook-form";

function SampleForm() {
  const { register, handleSubmit, watch, errors } = useForm();//useForm<Inputs>() peta

  let [emailMessage, setEmailMessage] = useState('');
  let [isLoading, setisLoading] = useState(false);

  const onLoad = () => {
    setTimeout(() => {
      $("*").each(function () {
        if (kn_translation) {
          if (kn_translation[$(this).attr('for')]) $(this).html(kn_translation[$(this).attr('for')]);
          if (kn_translation[$(this).data('trans')]) $(this).html(kn_translation[$(this).data('trans')]);
          if (kn_translation[$(this).attr('value')]) $(this).html(kn_translation[$(this).attr('value')]);
          if ($(this).data('trans') === "terms_and_conditions") $(this).attr("href", kn_variables.privacy_url);
        }
      })

      var formData = sessionStorage.getItem("formData") ? JSON.parse(sessionStorage.getItem("formData")) : null;
      if (formData) {
        for (var [key, value] of Object.entries(formData)) {
          if ($("input[type=text][name='"+key+"']").length) $("input[type=text][name='"+key+"']").val(value);
          if ($("input[type=email][name='"+key+"']").length) $("input[type=email][name='"+key+"']").val(value);
          if ($("select[name='"+key+"']").length) $("select[name='"+key+"']").val(value);
          if ($("textarea[name='"+key+"']").length) $("textarea[name='"+key+"']").val(value);
          if ($("input[type=checkbox][name='"+key+"']").length && (value == true || value == "true")) $("input[type=checkbox][name='"+key+"']").prop("checked", value);
          if (value.toString().indexOf(",") >= 0) {
            value.toString().split(",").forEach(value => {
              if ($("input[type=checkbox][name='"+key+"'][value='"+value+"']").length) $("input[type=checkbox][name='"+key+"'][value='"+value+"']").prop("checked", true);
            });
          } else if (value != true && value != false) {
            if ($("input[type=checkbox][name='"+key+"'][value='"+value+"']").length) $("input[type=checkbox][name='"+key+"'][value='"+value+"']").prop("checked", true);
          }
        }
        $("#submit").click()
      }
    }, 1)
  };

  const onSubmit = data => {
    if (data) sessionStorage.setItem("formData", JSON.stringify(data));

    console.log(data)

    document.getElementById("submit").disabled = true;

    setisLoading(true);

    $.ajax({
      method: "POST",
      data: data,
      url: kn_variables.template_url + '/blocks/forms/kn-form-5/kn-form-5-backend.php'
    }).then(res => {
      console.log('asd',res)
      const result = JSON.parse(res);

      // if success { message: 'your mail has been sent', success: true }
      // if failed { message: 'there was an error', success: false }

      setEmailMessage(result);
      setisLoading(false);

      // if (kn_form_5 && kn_form_5.attach)
      //   window.location.href = kn_variables.template_url + '/blocks/forms/kn-form-5/kn-form-5-backend.php?attach=' + kn_form_5.attach + '&return=' + encodeURI(kn_form_5.success_url.url + window.location.search);

      if (kn_form_5 && kn_form_5.success_url && kn_form_5.success_url.url)
        window.location.href = kn_form_5.success_url.url + '?attach=' + kn_form_5.attach + '&download=1';

    });

  };
  return (
    <div className="App">
      <form onLoad={onLoad()} onSubmit={handleSubmit(onSubmit)}>

        <input name="attach" type="hidden" value={ kn_form_5.attach } ref={register()} />

        <div>
          <label htmlFor="email" className="input-label">Email*</label>
          <input name="email" id="email" placeholder="" type="email" ref={register({ required: true, maxLength:50, pattern: {value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, message: "invalid email address"} })} />
          {errors.email && errors.email.type === "required" && <span className="field-required">*Required</span>}
        </div>

        <div>
          <label htmlFor="fullName" className="input-label">Full name*</label>
          <input name="fullName" id="fullName" type="text" ref={register({ required: true })} />
          {errors.fullName && errors.fullName.type === "required" && <span className="field-required">*Required</span>}
        </div>

        <div>
          <label htmlFor="jobTitle" className="input-label">Job title*</label>
          <input name="jobTitle" id="jobTitle" type="text" ref={register({ required: true })} />
          {errors.jobTitle && errors.jobTitle.type === "required" && <span className="field-required">*Required</span>}
        </div>

        <div>
          <label htmlFor="companyName" className="input-label">Company name*</label>
          <input name="companyName" id="companyName" type="text" ref={register({ required: true })} />
          {errors.companyName && errors.companyName.type === "required" && <span className="field-required">*Required</span>}
        </div>

        <div>
          <label htmlFor="country" className="input-label">Country*</label>
          <select name="country" defaultValue="" id="country" ref={register({ required: true })}>
            <option value="" disabled="disabled" data-trans="pleaseSelect">- Please select -</option>
            <option value="AFG">Afghanistan</option>
            <option value="ALA">Åland Islands</option>
            <option value="ALB">Albania</option>
            <option value="DZA">Algeria</option>
            <option value="ASM">American Samoa</option>
            <option value="AND">Andorra</option>
            <option value="AGO">Angola</option>
            <option value="AIA">Anguilla</option>
            <option value="ATA">Antarctica</option>
            <option value="ATG">Antigua and Barbuda</option>
            <option value="ARG">Argentina</option>
            <option value="ARM">Armenia</option>
            <option value="ABW">Aruba</option>
            <option value="AUS">Australia</option>
            <option value="AUT">Austria</option>
            <option value="AZE">Azerbaijan</option>
            <option value="BHS">Bahamas</option>
            <option value="BHR">Bahrain</option>
            <option value="BGD">Bangladesh</option>
            <option value="BRB">Barbados</option>
            <option value="BLR">Belarus</option>
            <option value="BEL">Belgium</option>
            <option value="BLZ">Belize</option>
            <option value="BEN">Benin</option>
            <option value="BMU">Bermuda</option>
            <option value="BTN">Bhutan</option>
            <option value="BOL">Bolivia, Plurinational State of</option>
            <option value="BES">Bonaire, Sint Eustatius and Saba</option>
            <option value="BIH">Bosnia and Herzegovina</option>
            <option value="BWA">Botswana</option>
            <option value="BVT">Bouvet Island</option>
            <option value="BRA">Brazil</option>
            <option value="IOT">British Indian Ocean Territory</option>
            <option value="BRN">Brunei Darussalam</option>
            <option value="BGR">Bulgaria</option>
            <option value="BFA">Burkina Faso</option>
            <option value="BDI">Burundi</option>
            <option value="KHM">Cambodia</option>
            <option value="CMR">Cameroon</option>
            <option value="CAN">Canada</option>
            <option value="CPV">Cape Verde</option>
            <option value="CYM">Cayman Islands</option>
            <option value="CAF">Central African Republic</option>
            <option value="TCD">Chad</option>
            <option value="CHL">Chile</option>
            <option value="CHN">China</option>
            <option value="CXR">Christmas Island</option>
            <option value="CCK">Cocos (Keeling) Islands</option>
            <option value="COL">Colombia</option>
            <option value="COM">Comoros</option>
            <option value="COG">Congo</option>
            <option value="COD">Congo, the Democratic Republic of the</option>
            <option value="COK">Cook Islands</option>
            <option value="CRI">Costa Rica</option>
            <option value="CIV">Côte d'Ivoire</option>
            <option value="HRV">Croatia</option>
            <option value="CUB">Cuba</option>
            <option value="CUW">Curaçao</option>
            <option value="CYP">Cyprus</option>
            <option value="CZE">Czech Republic</option>
            <option value="DNK">Denmark</option>
            <option value="DJI">Djibouti</option>
            <option value="DMA">Dominica</option>
            <option value="DOM">Dominican Republic</option>
            <option value="ECU">Ecuador</option>
            <option value="EGY">Egypt</option>
            <option value="SLV">El Salvador</option>
            <option value="GNQ">Equatorial Guinea</option>
            <option value="ERI">Eritrea</option>
            <option value="EST">Estonia</option>
            <option value="ETH">Ethiopia</option>
            <option value="FLK">Falkland Islands (Malvinas)</option>
            <option value="FRO">Faroe Islands</option>
            <option value="FJI">Fiji</option>
            <option value="FIN">Finland</option>
            <option value="FRA">France</option>
            <option value="GUF">French Guiana</option>
            <option value="PYF">French Polynesia</option>
            <option value="ATF">French Southern Territories</option>
            <option value="GAB">Gabon</option>
            <option value="GMB">Gambia</option>
            <option value="GEO">Georgia</option>
            <option value="DEU">Germany</option>
            <option value="GHA">Ghana</option>
            <option value="GIB">Gibraltar</option>
            <option value="GRC">Greece</option>
            <option value="GRL">Greenland</option>
            <option value="GRD">Grenada</option>
            <option value="GLP">Guadeloupe</option>
            <option value="GUM">Guam</option>
            <option value="GTM">Guatemala</option>
            <option value="GGY">Guernsey</option>
            <option value="GIN">Guinea</option>
            <option value="GNB">Guinea-Bissau</option>
            <option value="GUY">Guyana</option>
            <option value="HTI">Haiti</option>
            <option value="HMD">Heard Island and McDonald Islands</option>
            <option value="VAT">Holy See (Vatican City State)</option>
            <option value="HND">Honduras</option>
            <option value="HKG">Hong Kong</option>
            <option value="HUN">Hungary</option>
            <option value="ISL">Iceland</option>
            <option value="IND">India</option>
            <option value="IDN">Indonesia</option>
            <option value="IRN">Iran, Islamic Republic of</option>
            <option value="IRQ">Iraq</option>
            <option value="IRL">Ireland</option>
            <option value="IMN">Isle of Man</option>
            <option value="ISR">Israel</option>
            <option value="ITA">Italy</option>
            <option value="JAM">Jamaica</option>
            <option value="JPN">Japan</option>
            <option value="JEY">Jersey</option>
            <option value="JOR">Jordan</option>
            <option value="KAZ">Kazakhstan</option>
            <option value="KEN">Kenya</option>
            <option value="KIR">Kiribati</option>
            <option value="PRK">Korea, Democratic People's Republic of</option>
            <option value="KOR">Korea, Republic of</option>
            <option value="KWT">Kuwait</option>
            <option value="KGZ">Kyrgyzstan</option>
            <option value="LAO">Lao People's Democratic Republic</option>
            <option value="LVA">Latvia</option>
            <option value="LBN">Lebanon</option>
            <option value="LSO">Lesotho</option>
            <option value="LBR">Liberia</option>
            <option value="LBY">Libya</option>
            <option value="LIE">Liechtenstein</option>
            <option value="LTU">Lithuania</option>
            <option value="LUX">Luxembourg</option>
            <option value="MAC">Macao</option>
            <option value="MKD">Macedonia, the former Yugoslav Republic of</option>
            <option value="MDG">Madagascar</option>
            <option value="MWI">Malawi</option>
            <option value="MYS">Malaysia</option>
            <option value="MDV">Maldives</option>
            <option value="MLI">Mali</option>
            <option value="MLT">Malta</option>
            <option value="MHL">Marshall Islands</option>
            <option value="MTQ">Martinique</option>
            <option value="MRT">Mauritania</option>
            <option value="MUS">Mauritius</option>
            <option value="MYT">Mayotte</option>
            <option value="MEX">Mexico</option>
            <option value="FSM">Micronesia, Federated States of</option>
            <option value="MDA">Moldova, Republic of</option>
            <option value="MCO">Monaco</option>
            <option value="MNG">Mongolia</option>
            <option value="MNE">Montenegro</option>
            <option value="MSR">Montserrat</option>
            <option value="MAR">Morocco</option>
            <option value="MOZ">Mozambique</option>
            <option value="MMR">Myanmar</option>
            <option value="NAM">Namibia</option>
            <option value="NRU">Nauru</option>
            <option value="NPL">Nepal</option>
            <option value="NLD">Netherlands</option>
            <option value="NCL">New Caledonia</option>
            <option value="NZL">New Zealand</option>
            <option value="NIC">Nicaragua</option>
            <option value="NER">Niger</option>
            <option value="NGA">Nigeria</option>
            <option value="NIU">Niue</option>
            <option value="NFK">Norfolk Island</option>
            <option value="MNP">Northern Mariana Islands</option>
            <option value="NOR">Norway</option>
            <option value="OMN">Oman</option>
            <option value="PAK">Pakistan</option>
            <option value="PLW">Palau</option>
            <option value="PSE">Palestinian Territory, Occupied</option>
            <option value="PAN">Panama</option>
            <option value="PNG">Papua New Guinea</option>
            <option value="PRY">Paraguay</option>
            <option value="PER">Peru</option>
            <option value="PHL">Philippines</option>
            <option value="PCN">Pitcairn</option>
            <option value="POL">Poland</option>
            <option value="PRT">Portugal</option>
            <option value="PRI">Puerto Rico</option>
            <option value="QAT">Qatar</option>
            <option value="REU">Réunion</option>
            <option value="ROU">Romania</option>
            <option value="RUS">Russian Federation</option>
            <option value="RWA">Rwanda</option>
            <option value="BLM">Saint Barthélemy</option>
            <option value="SHN">Saint Helena, Ascension and Tristan da Cunha</option>
            <option value="KNA">Saint Kitts and Nevis</option>
            <option value="LCA">Saint Lucia</option>
            <option value="MAF">Saint Martin (French part)</option>
            <option value="SPM">Saint Pierre and Miquelon</option>
            <option value="VCT">Saint Vincent and the Grenadines</option>
            <option value="WSM">Samoa</option>
            <option value="SMR">San Marino</option>
            <option value="STP">Sao Tome and Principe</option>
            <option value="SAU">Saudi Arabia</option>
            <option value="SEN">Senegal</option>
            <option value="SRB">Serbia</option>
            <option value="SYC">Seychelles</option>
            <option value="SLE">Sierra Leone</option>
            <option value="SGP">Singapore</option>
            <option value="SXM">Sint Maarten (Dutch part)</option>
            <option value="SVK">Slovakia</option>
            <option value="SVN">Slovenia</option>
            <option value="SLB">Solomon Islands</option>
            <option value="SOM">Somalia</option>
            <option value="ZAF">South Africa</option>
            <option value="SGS">South Georgia and the South Sandwich Islands</option>
            <option value="SSD">South Sudan</option>
            <option value="ESP">Spain</option>
            <option value="LKA">Sri Lanka</option>
            <option value="SDN">Sudan</option>
            <option value="SUR">Suriname</option>
            <option value="SJM">Svalbard and Jan Mayen</option>
            <option value="SWZ">Swaziland</option>
            <option value="SWE">Sweden</option>
            <option value="CHE">Switzerland</option>
            <option value="SYR">Syrian Arab Republic</option>
            <option value="TWN">Taiwan, Province of China</option>
            <option value="TJK">Tajikistan</option>
            <option value="TZA">Tanzania, United Republic of</option>
            <option value="THA">Thailand</option>
            <option value="TLS">Timor-Leste</option>
            <option value="TGO">Togo</option>
            <option value="TKL">Tokelau</option>
            <option value="TON">Tonga</option>
            <option value="TTO">Trinidad and Tobago</option>
            <option value="TUN">Tunisia</option>
            <option value="TUR">Turkey</option>
            <option value="TKM">Turkmenistan</option>
            <option value="TCA">Turks and Caicos Islands</option>
            <option value="TUV">Tuvalu</option>
            <option value="UGA">Uganda</option>
            <option value="UKR">Ukraine</option>
            <option value="ARE">United Arab Emirates</option>
            <option value="GBR">United Kingdom</option>
            <option value="USA">United States</option>
            <option value="UMI">United States Minor Outlying Islands</option>
            <option value="URY">Uruguay</option>
            <option value="UZB">Uzbekistan</option>
            <option value="VUT">Vanuatu</option>
            <option value="VEN">Venezuela, Bolivarian Republic of</option>
            <option value="VNM">Viet Nam</option>
            <option value="VGB">Virgin Islands, British</option>
            <option value="VIR">Virgin Islands, U.S.</option>
            <option value="WLF">Wallis and Futuna</option>
            <option value="ESH">Western Sahara</option>
            <option value="YEM">Yemen</option>
            <option value="ZMB">Zambia</option>
            <option value="ZWE">Zimbabwe</option>
          </select>
          {errors.country && errors.country.type === "required" && <span className="field-required">*Required</span>}
        </div>

        <div>
          <label htmlFor="hearAbout" className="input-label">How did you hear about us?</label>
          <select name="hearAbout" defaultValue="" id="hearAbout" ref={register} >
            <option value="" disabled="disabled" data-trans="pleaseSelect">- Please select -</option>
            <option data-trans="hearAbout1" value="Search Engines">Google, Bing...</option>
            <option data-trans="hearAbout2" value="Social Media">Social Media</option>
            <option data-trans="hearAbout3" value="Trade fairs and events">Trade fairs and events</option>
            <option data-trans="hearAbout4" value="Referral">Referral</option>
            <option data-trans="hearAbout5" value="Other">Other</option>
          </select>
        </div>
        
        {/* <div>
          <label htmlFor="product" className="input-label">Product*</label>
          <select name="product" id="product" ref={register({ required: true })}>
            <option value="" selected={true} disabled="disabled" data-trans="pleaseSelect">- Please select -</option>
            <option value="flowbox">Flowbox</option>
            <option value="smartframe">Smartframe</option>
          </select>
          {errors.product && errors.product.type === "required" && <span className="field-required">*Required</span>}
        </div> */}

        {/* <div>
          <label htmlFor="comment" className="input-label">Message</label>
          <textarea name="comment" id="commment" rows="12" placeholder="" ref={register({ required: true, maxLength: 400 })} />
          {errors.comment && errors.comment.type === "required" && <span className="field-required">*Required</span>}
          {errors.comment && errors.comment.type === "maxLength" && <span className="field-required">*400 characters maximum</span> }
        </div> */}

        <div>
          <label className="accept-label">
            <input name="accept" id="accept" type="checkbox" ref={register({ required: true })}/>
            <span data-trans="iaccept">I Accept the</span> <a href="#" class="form-link" data-trans="terms_and_conditions">terms and conditions</a>
          </label>
        </div>

        <div>
          <label className="acceptinformed-label">
            <input name="acceptinformed" id="acceptinformed" type="checkbox" value="1" ref={register}/>
            <span data-trans="acceptInformedText">Please keep me informed about Kendu services, offerings and upcoming events.</span>
          </label>
        </div>

        <div id="submit-div">
          <button type="submit" id="submit" data-trans="download" className="kn-button-1 secondary animated fade-in-bottom">Download</button>
        </div>

        {/* <div className="email-sent">
          {isLoading && <img src={ kn_variables.template_url + '/assets/images/icons/icon_loading.gif' } className="loading-image" />}
          <div className={`success ${emailMessage && emailMessage.success === true ? "show" : "hidden"}`}>{ emailMessage.message }</div>
          <div className={`error ${emailMessage && emailMessage.success === false ? "show" : "hidden"}`}>{ emailMessage.message }</div>
        </div> */}

      </form>
    </div>
  );
}

class Form2 extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <SampleForm />;
  }
}

const form2Div = document.getElementById('kn-form-5-form');
ReactDOM.render(<Form2 />, form2Div);
